export enum TaskViewType {
  BOARD = 'Board',
  LIST = 'List',
}

export enum PageType {
  PLAYBOOK = 'Workstream',
  MYTASKS = 'Mytasks',
  RISKS = 'risks',
  ISSUES = 'issues',
  DECISIONS = 'Decisions',
  DEPENDENCIES = 'Dependencies',
  MILESTONE = 'Milestone',
  ARCHIVE = 'Archive',
  NOTIFICATIONS = 'Notification',
}

export enum AiQueryType {
  GENERALCHAT = 'generalchat',
  KNOWLEDGE = 'knowledge',
  USERDOCUMENT = 'userdocument',
  USERDOCSUMMARY = 'userdocsummary',
  WORKSTREAM = 'workstream',
}

export enum ActionItem {
  RISK = 'Risks',
  ISSUE = 'Issues',
  Decisions = 'Decisions',
}
